<app-page-body>
  <!-- header -->
  <app-page-header
    [showRefreshBtn]="false"
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "title" | translate }}
          </legend>

          <ul class="description">
            <li translate [translateParams]="{ allowedFiles: allowedFiles }">
              messages.onlyJpegAndPngAreAllowed
            </li>
            <li translate>messages.maxSizeIs1mb</li>
          </ul>
          <div *ngIf="!documentLoading" class="row">
            <div
              *ngFor="let item of DocumentationTypeEnumValues; let i = index"
              class="sm:tw-w-1/2 xl:tw-w-1/3"
            >
              <app-upload-documents
                [allowedFiles]="allowedFiles"
                [modelItems]="model"
                [documentType]="item"
                [documentTypes]="DocumentationTypeEnumValues"
                [documentStatusEnumValues]="DocumentStatusEnumValues"
                [blob]="getBlob(model[i]?.privateNumberPurchaseDocument)"
                type="privateNumber"
                [counter]="i"
                (items)="getUploadedItems($event)"
              ></app-upload-documents>
            </div>
          </div>
          <div class="row" *ngIf="documentLoading">
            <div class="tw-flex-center role-organizations-loading">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <span class="text-primary tw-text-lg tw-font-medium tw-mx-2">{{
                "common.loading" | translate
              }}</span>
            </div>
          </div>
        </fieldset>
      </section>
      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
<div id="fullpage" onclick="this.style.display='none';"></div>
